var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-info-badges"},_vm._l((_vm.bannerBadges),function(badge){return _c('BCXUserBadge',{key:badge.badge,attrs:{"badge":badge.badge,"theme-mode":_vm.badgeTheme},on:{"badge-clicked":function($event){return _vm.emit('badge-clicked')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }